import React from 'react';
import { connect } from 'react-redux';
import { shareProject as actionShareProject } from '@actions/projects';
import BaseModal from 'react-bootstrap/lib/Modal';

class ShareDialog extends React.PureComponent {
  constructor(...args) {
    super(...args);
    this.handleInput = this.handleInput.bind(this);

    this.state = {
      value: '',
    };
  }

  handleInput(e) {
    this.setState({ value: e.target.value });
  }

  render() {
    const { show, close, currentProject } = this.props;
    if (!currentProject) {
      return (
        <BaseModal show={show} onHide={close}>
          <BaseModal.Body>
            <div className="loader-task">
              <span className="fa fa-spinner fa-spin" />
              Loading...
            </div>
          </BaseModal.Body>
        </BaseModal>
      );
    }
    const projectLink = `https://app.progkids.com/project/shared/${currentProject._id}`;
    return (
      <BaseModal show={show} onHide={close}>
        <BaseModal.Header closeButton>
          <BaseModal.Title> Поделиться проектом </BaseModal.Title>
        </BaseModal.Header>
        <BaseModal.Body>
          <form>
            Вы хотите поделиться проектом <b>{currentProject.name}</b> <br />
            <a href={projectLink} target="_blank" rel="noopener noreferrer">
              {projectLink}
            </a>
            <label>Введите ник пользователя, которому отправим проект</label>
            <input
              type="text"
              className="form-control"
              id="name"
              placeholder="User name"
              onChange={this.handleInput}
              autoFocus
            />
            <div style={{ marginTop: '10px' }}>
              <button
                className="btn btn-success btn-block"
                disabled={!this.state.value}
                onClick={e => {
                  e.preventDefault();
                  this.props.shareProject(
                    currentProject.name,
                    currentProject.code,
                    this.state.value,
                    currentProject.lang
                  );
                  close();
                }}
              >
                Сохранить
              </button>
            </div>
          </form>
        </BaseModal.Body>
      </BaseModal>
    );
  }
}

function mapStateToProps(state) {
  const { current: currentProject } = state.projects;

  return {
    currentProject,
  };
}

const mapDispatchToProps = dispatch => ({
  shareProject: (name, code, target, lang) =>
    dispatch(actionShareProject(name, code, target, lang)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ShareDialog);
